<template>
  <q-dialog ref="dialog" @hide="onDialogHide" persistent>
    <i-page class="q-dialog-plugin dialog-mini">
      <div class="dialog-details-title" style="margin-bottom: 1.5em;">{{title}}</div>
      <q-form ref="form" @reset="onFormReset()">
        <i-field ref="txtOldPwd" v-model="model.oldPwd" prepend-icon="vpn_key" type="password" label="旧密码" :rules="[rules.required]"
          @keydown.enter.prevent="onFieldEnter($refs.txtOldPwd, $refs.txtNewPwd1)" />
        <i-field ref="txtNewPwd1" v-model="model.newPwd1" prepend-icon="vpn_key" type="password" label="新密码" :rules="[rules.required]"
          @keydown.enter.prevent="onFieldEnter($refs.txtNewPwd1, $refs.txtNewPwd2)" />
        <i-field ref="txtNewPwd2" v-model="model.newPwd2" prepend-icon="vpn_key" type="password" label="确认新密码" :rules="[rules.required]"
          @keydown.enter.prevent="onFieldEnter($refs.txtNewPwd2, onOKClick)" />
      </q-form>
      <div class="dialog-mini-actions">
        <q-btn color="primary" label="取消" flat rounded @click="onCancelClick" icon="clear" />
        <q-btn color="primary" label="确定" rounded @click="onOKClick" icon="done" :loading="okLoading" :disable="okLoading" />
      </div>
    </i-page>
  </q-dialog>
</template>
<script>
import { StoreBisDicMixin, StoreBisAuthorizeMixin } from '@/lib/mixins'
import rules from '@/lib/rules.js'
import utils from '@/lib/utils'

export default {
  mixins: [StoreBisDicMixin, StoreBisAuthorizeMixin],
  data: function () {
    return {
      rules,
      model: {
        oldPwd: null,
        newPwd1: null,
        newPwd2: null
      },
      okLoading: false
    }
  },
  props: {
    userId: {
      type: String
    }
  },
  computed: {
    title () {
      return `修改密码 - ${this.computedUser?.name}(${this.computedUser?.username})`
    },
    computedUserId () {
      return this.userId ?? this.$$user?.id
    },
    computedUser () {
      return this.$$userById(this.computedUserId)
    }
  },
  mounted () {
    this.reset()
  },
  methods: {
    onFormReset () {
      utils.reset(this.model)
    },
    reset () {
      this.$refs.form && this.$refs.form.reset()
      setTimeout(() => {
        this.$refs.txtOldPwd && this.$refs.txtOldPwd.focus()
      }, 200)
    },
    onFieldEnter (current, next) {
      setTimeout(async () => {
        const outcome = await current.validate()
        if (outcome) {
          if (typeof (next) === 'function') {
            next()
          } else {
            next.focus()
          }
        }
      }, 200)
    },
    async validate () {
      if (this.$refs.form) {
        const valid = await this.$refs.form.validate()
        if (!valid) {
          return false
        }
      }
      if (this.model.oldPwd === this.model.newPwd1) {
        this.$q.notify({
          type: 'negative',
          message: '新旧密码相同'
        })
        this.$refs.txtOldPwd && this.$refs.txtOldPwd.focus()
        return false
      }
      if (this.model.newPwd1 !== this.model.newPwd2) {
        this.$q.notify({
          type: 'negative',
          message: '两次输入的新密码不一致'
        })
        this.$refs.txtNewPwd1 && this.$refs.txtNewPwd1.focus()
        return false
      }
      return true
    },
    async submit () {
      const valid = await this.validate()
      if (!valid) {
        return false
      }
      const form = new FormData()
      form.append('password', this.model.newPwd1)
      form.append('oldPassword', this.model.oldPwd)
      const modifyResult = await this.$$api.bis.put(
        // this.userId ? `/user/password/${this.userId}` : '/user/password',
        `/user/password/${this.computedUserId}`,
        form,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded' // 普通表单提交的Content-Type
            // 'Content-Type': 'multipart/form-data' // 含有附件的表单提交的Content-Type
          }
        })
      modifyResult.notify(modifyResult.success ? '修改密码成功' : null)
      return modifyResult.success
    },

    // following method is REQUIRED
    // (don't change its name --> "show")
    show () {
      this.$refs.dialog.show()
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide () {
      this.$refs.dialog.hide()
    },

    onDialogHide () {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide')
    },

    async onOKClick () {
      const success = await this.submit()
      if (!success) {
        return
      }
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok')
      this.hide()
    },

    onCancelClick () {
      // we just need to hide dialog
      this.hide()
    }
  }
}
</script>
